/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Sampling_BalancedInputs */



/**
* | output |
* | --- |
* | "1s (Balanced)" |
*
* @param {Ocr_Sampling_BalancedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_sampling_balanced = /** @type {((inputs?: Ocr_Sampling_BalancedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Sampling_BalancedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("1s (Équilibré)")
	if (locale === "de") return /** @type {LocalizedString} */ ("1s (Ausgewogen)")
	if (locale === "it") return /** @type {LocalizedString} */ ("1s (Bilanciato)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("1 с (сбалансированный)")
	if (locale === "es") return /** @type {LocalizedString} */ ("1s (Equilibrado)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("1秒（平衡）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1秒（バランス型）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("1s (संतुलित)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("1s (Equilibrado)")
	return /** @type {LocalizedString} */ ("1s (Balanced)")
});